var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple authentication-form"},[_vm._t("header"),_c('main',{staticClass:"auth-container"},[(_vm.loading)?_c('Spinner',{attrs:{"size":16,"thickness":3}}):_c('Authenticate',{attrs:{"defaultTab":"signin","registration":false}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }